import { Component, OnInit, Input } from "@angular/core";
import { Location } from "@angular/common";
import { BreadcrumbService } from '../../app.breadcrumb.service';
import { MenuItem } from 'primeng/api';
import { MessageService, ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../base/base-component';
import { Emprunt } from '../../entites/emprunt';
import { EmpruntService } from '../../services/emprunt.service';
import { DonneesBaseService } from '../../services/donnees-base-service';
import { ProfilService } from '../../services/profil-service';
import { AppMainComponent } from '../../app.main.component';
import { Observable, of } from 'rxjs';
import { SelectionEmplacementComponent } from "src/app/controles/selection-emplacement.component";
import { SelectionEmployeComponent } from "src/app/controles/selection-employe.component";
import { EmployeEntite } from "src/app/entites/employe";
import { Emplacement } from "src/app/entites/emplacement";
import { EStatuts } from "src/app/entites/enums/statuts";

@Component({
    selector: 'app-detail-emprunt',
    templateUrl: './detail-emprunt.component.html',
    styleUrls: ['./detail-emprunt.component.scss'],
    providers: [MessageService, ConfirmationService, DialogService]
})
export class DetailEmpruntComponent extends BaseComponent implements OnInit {

    @Input('empruntId') inputEmpruntId: number;

    empruntId: number;
    emprunt: Emprunt;

    menu: MenuItem[];

    submitted: boolean = false;
    modeApercu: boolean = false;

    minDateRetour: Date = new Date();

    afficherDetailItem: boolean = false;
    detailItemId: number;

    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute,
        appMain: AppMainComponent, 
        location: Location, 
        private breadcrumbService: BreadcrumbService,
        private empruntService: EmpruntService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        public dialogService: DialogService,
        public routerService: Router) {

        super(sdb, profilService, route, routerService, appMain);

        this.breadcrumbService.setItems([
            { label: 'Emprunts', routerLink: '/emprunt' },
            { label: 'Détails' }
        ]);

        this.route.params.subscribe(params => {
            this.empruntId = params.id || this.inputEmpruntId;
        });
    }

    ngOnInit() {
        this.verifierAccesPage('emprunt');
        if (this.empruntId) {
            this.chargerEmprunt();
        }
    }

    private chargerEmprunt(): void {
        this.DemarrerChargement();

        this.empruntService.getEmpruntById(this.empruntId).subscribe({
            next: (emprunt) => {
                this.emprunt = emprunt;
                this.preparerMenu();
                this.CompleterChargement();
            },
            error: (error) => {
                this.messageService.add({
                    severity: 'error', 
                    summary: 'Erreur', 
                    detail: 'Impossible de charger l\'emprunt'
                });
                this.CompleterChargement();
            }
        });
    }

    private preparerMenu(): void {
        this.menu = [];

        this.menu.push({
            label: 'Retour',
            icon: 'pi pi-fw pi-angle-double-left',
            command: () => window.history.back()
        });

        this.menu.push({
            label: 'Supprimer',
            icon: 'pi pi-trash',
            command: () => this.supprimer(),
            visible: this.emprunt?.statut.statutId == EStatuts.EnAttente && (this.emprunt.demandeParId == this.profilService.ProfilCourant().employeId || this.estAutorise('admin_emprunt'))
        });

        this.menu.push({
            label: 'Retourner l\'item',
            icon: 'pi pi-undo',
            command: () => this.retourner(),
            visible: (this.emprunt?.statut.statutId == EStatuts.Actif || this.emprunt?.statut.statutId == EStatuts.EnRetard) && (this.emprunt.demandeParId == this.profilService.ProfilCourant().employeId || this.estAutorise('admin_emprunt'))
        });
    }

    surBoutonModifier(): void {
        this.Modifier();
    }

    enregistrerModifications(): void {
        this.submitted = true;

        if (this.validerFormulaire()) {
            this.empruntService.updateEmprunt(this.empruntId, this.emprunt).subscribe({
                next: (empruntMiseAJour) => {
                    this.messageService.add({
                        severity: 'success', 
                        summary: 'Succès', 
                        detail: 'Emprunt mis à jour avec succès'
                    });
                    this.Consulter();
                    this.submitted = false;
                },
                error: (error) => {
                    this.messageService.add({
                        severity: 'error', 
                        summary: 'Erreur', 
                        detail: 'Impossible de mettre à jour l\'emprunt'
                    });
                }
            });
        }
    }

    surBoutonAnnulerModification(event: Event): void {
        this.confirmationService.confirm({
            target: event.target,
            message: 'Êtes-vous sûr de vouloir annuler les modifications?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.chargerEmprunt();
                this.Consulter();
                this.submitted = false;
            }
        });
    }

    private retourner(): void {
        const confirmationAction = () => {
            this.confirmationService.confirm({
                message: `Êtes-vous sûr de vouloir effectuer un retour de cet emprunt à l'emplacement ${this.emprunt.emplacementRetour?.nom}?`,
                header: 'Confirmation de retour manuel',
                icon: 'pi pi-info-circle',
                accept: () => {
                    this.routerService.navigate(['/emprunt/retour', this.empruntId], {
                        queryParams: {
                            EmplacementId: this.emprunt.emplacementRetourId
                        }
                    });
                }
            });
        };

        if (this.emprunt.emplacementRetour) {
            confirmationAction();
        } else {
            this.dialogService.open(SelectionEmplacementComponent, {
                header: 'Sélectionner un emplacement de retour',
                width: '50%',
                data: {
                    selection: this.emprunt.emplacementDepart?.emplacementId
                }
            }).onClose.subscribe((result: Emplacement) => {
                if (result) {
                    this.emprunt.emplacementRetour = result;
                    this.emprunt.emplacementRetourId = result.emplacementId;
                    confirmationAction();
                }
            });
        }
    }

    selectionnerEmploye(retour: boolean = false): void {
        this.dialogService.open(SelectionEmployeComponent, {
          header: 'Selectionner un employé',
          width: '50%',
        }).onClose.subscribe((result: EmployeEntite) => {
          if (result) {
            if (retour) {
              this.emprunt.employeRetour = result;
              this.emprunt.employeRetourId = result.employeId;
            } else {
              this.emprunt.employe = result;
              this.emprunt.employeId = result.employeId;
            }
          }
        });
      }
    
      selectionnerEmplacement(retour: boolean = false): void {
        this.dialogService.open(SelectionEmplacementComponent, {
          header: 'Selectionner un emplacement',
          width: '50%',
          height: '50%',
        }).onClose.subscribe((result: Emplacement) => {
          if (result) {
            if (retour) {
              this.emprunt.emplacementRetour = result;
              this.emprunt.emplacementRetourId = result.emplacementId;
            } else {
              this.emprunt.emplacementDepart = result;
              this.emprunt.emplacementDepartId = result.emplacementId;
            }
          }
        });
      }

    private validerFormulaire(): boolean {
        // Add validation logic here
        return true;
    }

    afficherItem(itemId: number): void {
        this.detailItemId = itemId;
        this.afficherDetailItem = true;
    }

    /**
     * Checks if the DateAjout of an empruntEnfant differs from the DateCreation of the parent emprunt (date part only)
     * @param empruntEnfant The child emprunt to check
     * @returns true if the dates differ (ignoring time), false otherwise
     */
    shouldShowDateAjout(empruntEnfant: any): boolean {
        if (!empruntEnfant?.dateAjout || !this.emprunt?.dateCreation) {
            return false;
        }

        const dateAjout = new Date(empruntEnfant.dateAjout);
        const dateCreation = new Date(this.emprunt.dateCreation);

        // Compare only the date part (year, month, day)
        return dateAjout.toDateString() !== dateCreation.toDateString();
    }

    supprimer(): void {
        this.confirmationService.confirm({
            message: 'Êtes-vous sûr de vouloir supprimer cet emprunt?',
            header: 'Confirmation de suppression',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.empruntService.deleteEmprunt(this.empruntId).subscribe({
                    next: () => {
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Succès',
                            detail: 'Emprunt supprimé avec succès'
                        });
                        this.routerService.navigate(['/emprunt']);
                    }
                });
            }
        });
    }
}  